import * as RadixLabel from '@radix-ui/react-label';
import { wrapClassNames } from '@ui/utils/tailwind';
import { forwardRef } from 'react';

const labelVariants = {
  default: 'font-semibold',
  light: 'font-medium',
  regular: 'font-normal',
};

type LabelVariant = keyof typeof labelVariants;

export interface LabelProps extends RadixLabel.LabelProps {
  variant?: LabelVariant;
  tw?: never;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ children, variant = 'default', className, ...rest }, ref) => {
    return (
      <RadixLabel.Root
        className={wrapClassNames(`text-ui2-sm text-neutral-800 ${labelVariants[variant]} ${className}`)}
        ref={ref}
        {...rest}
      >
        {children}
      </RadixLabel.Root>
    );
  }
);
